import api from "./portalAPI";

const service = {
  login(username, password) {
    return api.post(`/Login`, { username, password });
  },
};

export default service;
